<ng-container>
  <div class="company-address-container pr-0 pl-0">
    <span class="company-address-container__header">
      {{ "LABELS.BUSINESS_ADDRESS" | translate }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'COMPANY.BANNED_ADDRESS.TEXT' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex" [formGroup]="formGroup">
      <div
        class="company-address-container-form pr-0 pl-0"
        [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }"
      >
        <address-update
          [formGroup]="formGroup"
          [errors]="errors"
          [defaultCountry]="isForeignImporter ? null : defaultCountry"
          [typeView]="enumTypeView.COMPANY"
          [isFilterRestrictedCountries]="true"
          [isAllowCountryDisable]="isDisableCountry"
          [isUnitedStates]="isUnitedStates"
        ></address-update>
        <!-- #13189 banned registered-agent address — section-wide validation message -->
        <div
          class="company-address-container-banned-error"
          *ngIf="isBannedAddress"
          [innerHTML]="'COMPANY.BANNED_ADDRESS.TEXT' | translate"
        ></div>
      </div>
      <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
        <div class="company-address-container-description">
          <span [innerHTML]="'COMPANY.BANNED_ADDRESS.TEXT' | translate"></span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
